import { Modal, Col, Row, Space, Typography, Dropdown, message } from "antd";
import AssetSubtypesFormDialog from "../components/AssetSubtypesFormDialog";
import { useState } from "react";
import { Guid } from "guid-typescript";
import AssetSubtypesView from "../components/AssetSubtypesView";
import { SearchQuery } from "../code/search-query/search-query";
import { getAssetSubtypesExport } from "../repository/data.repository";
import Loader from "../controls/Loader";
import { AssetSubtype } from "../repository/data.default";
import { useSelector } from "../store/store";
import { authorizeSelectors } from "../store/authorize";
import { getProblemMessage } from "../utils/http";

function AssetSubtypesPage() {
  const [modal, contextHolder] = Modal.useModal();
  const [searchQuery, setSearchQuery] = useState<SearchQuery>({
    conditions: [],
  });
  const [inputMode, setInputMode] = useState<"add" | "update" | "delete">("add");
  const [inputOpen, setInputOpen] = useState(false);
  const [inputValues, setInputValues] = useState<AssetSubtype>({} as any);
  const [triggerView, setTriggerView] = useState(Guid.create().toString());
  const permissions = useSelector(authorizeSelectors.permissions);

  function onSearch(searchQuery: SearchQuery): void {
    setSearchQuery(searchQuery);
  }

  function onInputOpen(
    mode: "add" | "update" | "delete",
    values?: AssetSubtype,
  ): void {
    setInputMode(mode);
    setInputOpen(true);
    setInputValues(values || ({} as any));
  }

  function onInputFinish(): void {
    setInputOpen(false);
    setTriggerView(Guid.create().toString());
  }

  function onInputClose(): void {
    setInputOpen(false);
  }

  function onDownloadExport(): void {
    const loading = modal.info({
      content: (
        <Typography.Text className="m-1 ml-2 inline-block">
          Downloading asset-subtypes export file..
        </Typography.Text>
      ),
      footer: null,
      centered: true,
      icon: <Loader />,
    });
    getAssetSubtypesExport({
      searchQuery,
      pageNumber: 0,
      pageSize: Number.MAX_SAFE_INTEGER,
    })
      .then(() => loading.destroy())
      .catch((err) => {
        loading.destroy();
        message.error(getProblemMessage(err) || "Failed to download export.");
      });
  }

  return (
    <Col className="relative flex flex-auto flex-col overflow-hidden overflow-y-auto">
      <Row className="sticky top-0 z-10 flex flex-row flex-wrap items-center p-4">
        <Typography.Title className="m-0 flex-auto" level={4}>
          Asset Subtypes
        </Typography.Title>
        <Space className="flex flex-row">
          <Dropdown.Button
            type="primary"
            disabled={!permissions.can("AssetSubtypes", "create")}

            className={`${!permissions.can("AssetSubtypes", "create") ? "disabled" : ""}`}
            menu={{
              items: [
                {
                  key: "downloadExport",
                  label: "Export to Excel",
                  disabled: !permissions.can("AssetSubtypes", "view"),
                  onClick: onDownloadExport,
                },
              ],
            }}
            onClick={() => onInputOpen("add")}
          >
            Add Asset Subtype
          </Dropdown.Button>
        </Space>
      </Row>
      <Col className="flex flex-auto flex-col overflow-hidden p-4 pb-4 pt-0">
        <AssetSubtypesView
          trigger={triggerView}
          onAction={(key: string, record: any) =>
            onInputOpen(key as any, record)
          }
          onSearch={onSearch}
        />
      </Col>
      <AssetSubtypesFormDialog
        mode={inputMode}
        open={inputOpen}
        initialValues={inputValues}
        onFinish={onInputFinish}
        onCancel={onInputClose}
      />
      {contextHolder}
    </Col>
  );
}

export default AssetSubtypesPage;
